import { Button, DemoWidget, Image, Loader, Text, TextSize, Weight } from 'components'
import styled from 'styled-components'

export const ProductOverview = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 75px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    padding: 0 40px;
    flex-direction: column;
  `};
  ${({ theme }) => theme.mediaWidth.Tablet`
    gap: 45px;
  `};
`

export const PerformanceWrapper = styled.div<{ isIndex: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.bg};
  box-shadow: ${({ theme }) => theme.boxShadow};
  border-radius: 20px;
  padding: 15px;
  margin-top: 30px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 20px;
  `};

  ${({ isIndex }) => !isIndex && `margin-bottom: 70px`};
  ${({ theme, isIndex }) => theme.mediaWidth.Tablet`
    padding: 20px;
    ${!isIndex && `margin-bottom: 70px`};
  `};
  ${({ theme, isIndex }) => theme.mediaWidth.Desktop`
    padding: 20px;
    ${!isIndex && `margin-bottom: 20px`};
  `};
`

export const PageWrapper = styled.div`
  display: block;
  ${({ theme }) => theme.mediaWidth.Desktop`
    margin: auto;
  `}
`

export const ContentWrapper = styled.div`
  flex: 1;
  box-sizing: border-box;
  width: 100%;
  ${({ theme }) => theme.mediaWidth.Desktop`
    width: calc(100% - 350px);
  `};
`

export const IndexInfoWrapper = styled.div`
  ${({ theme }) => theme.mediaWidth.Mobile`
    padding: 15px;
  `};
  padding: 30px;
  margin-top: 30px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.bg};
  box-shadow: ${({ theme }) => theme.boxShadow};
  display: flex;
  flex-direction: column;
  width: fill-available;
  border-radius: 20px;
  ${({ theme }) => theme.mediaWidth.Tablet`
    padding: 30px;
  `};
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 20px;
  `};
`

export const OverviewTitleArea = styled.div`
  display: flex;
  justify-content: space-between;
`

export const OverviewTitle = styled(Text)`
  letter-spacing: -0.01em;
`

export const OverviewText = styled(Text)`
  margin-top: 15px;
  line-height: 21px;
  letter-spacing: -0.01em;
  color: ${({ theme }) => theme.titleColor};
  font-size: ${TextSize.four};
  ${({ theme }) => theme.mediaWidth.Desktop`
    font-size: ${TextSize.p}
  `};
`

export const CustomSubtitle = styled(Text)`
  line-height: 18px;
  min-width: 50px;
  color: ${({ theme }) => theme.titleColor};
  font-size: ${TextSize.four};
  ${({ theme }) => theme.mediaWidth.Desktop`
     font-size: ${TextSize.p};
  `}
`

export const ChartWrapper = styled.div`
  overflow-y: none;
  display: flex;
  flex-direction: column;
  overflow-y: visible;
  width: 100%;
  min-width: auto;
`
export const InfoWrapper = styled.div`
  display: grid;
  margin-top: 15px;
`

export const Box = styled.div``

export const FirstInfoFragment = styled.div`
  display: flex;
  padding-bottom: 5px;
  flex-direction: column;
`

export const MetricsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.mediaWidth.Desktop`
    flex-direction: row;
    justify-content: space-between;
    gap:10px;
  `}
`

export const InfoText = styled(Text)`
  display: flex;
  margin-top: 8px;
  font-size: ${TextSize.p};
  ${({ theme }) => theme.mediaWidth.Desktop`
     font-size: ${TextSize.nav};
  `}
`

export const CoinImg = styled(Image)`
  background-size: cover;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  margin-right: 5px;
`

export const StyledLoader = styled(Loader)`
  margin-top: 30%;
`

export const WidgetLoadingWrapper = styled.div<{ isSmaller: boolean }>`
  height: ${({ isSmaller }) => (isSmaller ? '340px' : '360px')};
  width: ${({ isSmaller }) => (isSmaller ? '280px' : '295px')};
  margin-top: 35px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  `};
`

export const StyledWidgetSkeletonWrapper = styled.div`
  position: relative;
  width: 295px;
  height: 360px;
`

export const StyledDemoWidget = styled(DemoWidget)`
  z-index: 2;
  position: fixed !important;
  right: 10px;
  top: 50px;
`

export const WhiteStyledDemoWidget = styled(StyledDemoWidget)`
  background-color: transparent;
`

export const BuyButton = styled(Button)`
  position: absolute;
  right: 20px;
  bottom: 20px;
  width: 140px;
  font-weight: ${Weight.Medium};
  font-size: ${TextSize.p};
  box-shadow: 0px 3px 2px rgba(17, 2, 107, 0.5);
  ${({ theme }) => theme.mediaWidth.Mobile`     
    bottom: 22px
  `}
`

export const Wrapper = styled.div`
  cursor: pointer;
  width: 20px;
  height: 20px;
`

// wraps the block explorer badge on product overview page
export const BadgeWrapper = styled.div`
  position: relative;
  top: -2px;
  margin: 0 auto;
  img {
    position: absolute;
    left: 0;
    transition: opacity 0.2s ease-in-out;
  }
`

export const StyledBlockExplorerImage = styled(Image)`
  width: 20px;
  height: 20px;
  background-color: ${({ theme }) => theme.bg};
  &:hover {
    opacity: 0;
  }
`
export const HoverBlockExplorerImage = styled(Image)`
  width: 20px;
  height: 20px;
  &:hover {
    opacity: 1;
  }
`

export const StyledTitle = styled(Text)`
  font-size: ${TextSize.p};
  ${({ theme }) => theme.mediaWidth.Desktop`
    font-size: ${TextSize.nav};
  `}
`

export const StickyBuyButtonWrapper = styled.div`
  position: sticky;
  right: 20px;
  bottom: 10px;
`

//style wrapper for the badges
export const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`

export const BadgeIconWrapper = styled.div<{
  hoverColor?: string
  stroke: string
}>`
  cursor: pointer;
  height: auto;
  width: auto;
  & svg {
    transition: all 0.2s ease-in-out;
    width: 24px;
    height: 24px;
    & path {
      ${({ stroke }) => {
        return `stroke: ${stroke};`
      }}
    }
  }
  &:hover > svg {
    & path {
      ${({ hoverColor, stroke }) => `stroke: ${hoverColor ? hoverColor : stroke}`};
    }
  }
`

export const ExpandedBoxStyle = styled(Box)`
  width: 100%;
`
export const FixedHeightLoader = styled(Loader)`
  min-height: 800px;
`

export const ProductCoverSkeletonWrapper = styled.div`
  margin: 35px 20px 0 20px;
  width: fill-available;
  display: flex;
  flex-direction: column;
  gap: 30px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin: 70px 0 0 0;
    gap: 20px;
  `};
`
export const ProductCoverSkeletonRow = styled.div<{ isApy: boolean }>`
  display: flex;
  gap: ${({ isApy }) => (isApy ? '30px' : '40px')};
  ${({ theme }) => theme.mediaWidth.Mobile`
    gap: 20px;
  `};
`

export const SkeletonWrapper = styled.div`
  width: 100%;
  margin-top: 30px;
  ${({ theme }) => theme.mediaWidth.Mobile`
    margin-top: 20px;
  `};
`

export const SkeletonContainer = styled.div`
  margin-top: 30px;
`

export const MainContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`
